import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from '../assets/img/logo.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import navIcon4 from '../assets/img/nav-icon4.svg';
import { HashLink } from 'react-router-hash-link';
import { BrowserRouter as Router } from "react-router-dom";

export const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const onScroll = () => {
      const homeSection = document.getElementById('home');
      const skillsSection = document.getElementById('skills');
      const experienceSection = document.getElementById('experience');
      const projectsSection = document.getElementById('projects');

      if (homeSection && window.scrollY < (homeSection.offsetHeight - 100)) {
      setActiveSection('home');
      } else if (skillsSection && window.scrollY < (homeSection.offsetHeight + skillsSection.offsetHeight - 100)) {
      setActiveSection('skills');
      } else if (experienceSection && window.scrollY < (homeSection.offsetHeight + skillsSection.offsetHeight + experienceSection.offsetHeight - 100)) {
      setActiveSection('experience');
      } else if (projectsSection) {
      setActiveSection('projects');
      } else {
      setActiveSection('');
      }

      if (window.scrollY > 50) {
      setScrolled(true);
      } else {
      setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Router>
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand href="#home">
            <img src={logo} alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link className="navbar-link" href="#home" active={activeSection === 'home'}>Home</Nav.Link>
              <Nav.Link className="navbar-link" href="#skills" active={activeSection === 'skills'}>Skills</Nav.Link>
              <Nav.Link className="navbar-link" href="#experience" active={activeSection === 'experience'}>Experience</Nav.Link>
              <Nav.Link className="navbar-link" href="#projects" active={activeSection === 'projects'}>Projects</Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a href="https://linkedin.com/in/frisrsyd" target="_blank" rel="noreferrer"><img src={navIcon1} alt="LinkedIn Icon" /></a>
                <a href="https://github.com/frisrsyd" target="_blank" rel="noreferrer"><img src={navIcon2} alt="Github Icon" /></a>
                <a href="https://instagram.com/frisrsyd" target="_blank" rel="noreferrer"><img src={navIcon3} alt="Instagram Icon" /></a>
                <a href="https://ko-fi.com/frisrsyd" target="_blank" rel="noreferrer"><img src={navIcon4} alt="Instagram Icon" /> </a>
              </div>
              <HashLink to='#connect'>
                <button className="vvd"><span>Let’s Connect</span></button>
              </HashLink>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  )
}
